import styled from 'styled-components'

const Container = styled.div<{ height: number | undefined }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  background-color: rgba(208, 212, 221, 0.5);
  z-index: 999999;
`

const Loading = styled.div`
  position: relative;
  width: 2em;
  height: 2em;
  border: 4px solid;
  border-top-color: transparent;
  border-right-color: black;
  border-bottom-color: black;
  border-left-color: black;
  border-radius: 50%;
  animation: loadingAnimation 1s infinite linear;
  opacity: 0.5;

  @keyframes loadingAnimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

interface LoaderSkeletonProps {
  height: number | undefined
}

function LoaderSkeleton(props: LoaderSkeletonProps) {
  return (
    <>
      <Container {...props}>
        <Loading />
      </Container>
    </>
  )
}

export default LoaderSkeleton
